import { gql } from 'graphql-request'

export const CHECK_USER_EXIST = gql`
  query CheckUserExist($userIds: [Int!]!) {
    checkUserExist(userIds: $userIds)
  }
`
